module.exports = __webpack_public_path__ + "img/liu.983f399e.svg";